<template>
  <div class="text_left">
    <title-bar-back :title="'选择退款类型'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 退款商品 -->
    <div class="order_info">
      <!-- 退款商品店铺 -->
      <order-shop-head />
      <!-- 退款商品信息 -->
      <order-product-list
        v-for="(item, index) in refundProductList"
        :key="index"
        :bgPad="'bg0'"
        :pageShow="false"
        :item="item"
      />
    </div>
    <!-- 退货类型-->
    <div v-if="!isUnPicked" class="total_price1 clearfix">
      <div v-for="(item, index) in refundList" :key="index">
        <div
          v-if="!(orderType === 0 && index === 0)"
          :class="{ bor_line_bottom: index !== 0 }"
          class="bor_line"
          @click="goRefund(index, item.path)"
        >
          <span>{{ item.title }}</span>
          <img
            src="@/assets/common/icon_back_b87_24@2x.png"
            alt=""
            class="right go_right"
          />
          <div class="refund_det">{{ item.det }}</div>
        </div>
      </div>
    </div>

    <!-- 自提未提货的温馨提醒和退款信息展示 -->
    <div v-else class="unpicked_con">
      <!-- 温馨提醒 -->
      <div class="warn_con text_left">
        <div class="warn_title font14 font_weight500">温馨提醒</div>
        <div class="warn_text font12 line_height_18">
          由于支付手续费在您付款成功后已由第三方支付机构即时收取，手续费约为剩余商品金额2%~3%（具体以支付渠道规则为准），且该费用不可退还，因此当您取消订单时，退款金额将扣除这部分手续费。<br />谢谢您的理解。
        </div>
      </div>
      <!-- 退款信息 -->
      <div class="info_con font12">
        <div class="info_item">
          <span class="info_label text_left">退款方式：</span>
          <span class="info_val">按照原路返回</span>
        </div>
        <div class="info_item">
          <span class="info_label text_left">退款联系人：</span>
          <span class="info_val">{{ getContactor.username || "" }}</span>
        </div>
        <div class="info_item">
          <span class="info_label text_left">联系方式：</span>
          <span class="info_val">{{ getContactor.phone || "" }}</span>
        </div>
      </div>
      <div class="bottom_placeholder"></div>
      <!-- 提交按钮 -->
      <div class="bottom_btn_wrapper">
        <div
          class="submit_btn text_center font14 font_weight500 colof"
          @click="onSubmitUnPicked"
        >
          提交
        </div>
      </div>
    </div>
    <div v-if="orderType === 1" class="milk_det">
      <div>鲜奶售后说明:</div>
      <div>鲜奶为生鲜产品，请及时签收并开箱查验!</div>
      <div>1、如果存在问题请立刻发起售后；</div>
      <div>2、务必拍照存证、上传。如因个人原因造成的问题，不在售后范围内。</div>
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import OrderShopHead from "./components/OrderShopHead";
import OrderProductList from "../../list/components/OrderProductList";
export default {
  name: "ChooseRefundType",
  components: {
    TitleBarBack,
    OrderShopHead,
    OrderProductList
  },
  data() {
    return {
      refundList: [
        {
          title: "我要退款（无需退货）",
          det: "没收到货，或已收到货只退款不需要退货",
          path: `/order/refund/applyrefund?refundType=0&subOrderSn=${this.$route.query.subOrderSn}&orderSn=${this.$route.query.orderSn}&orderType=${this.$route.query.orderType}`
        },
        {
          title: "我要退货退款",
          det: "已收到货，需要退还已收到的货物",
          path: `/order/refund/applyrefund?refundType=1&subOrderSn=${this.$route.query.subOrderSn}&orderSn=${this.$route.query.orderSn}&orderType=${this.$route.query.orderType}`
        }
      ],
      // detail: {},
      refundProductList: [],
      orderType: 0
    };
  },
  computed: {
    isUnPicked() {
      const subOrderSn = this.$route.query.subOrderSn;
      return subOrderSn && subOrderSn.includes("UNPICKED");
    },
    getPeriodOptionalAfterOrder() {
      return this.$store.getters.getPeriodOptionalAfterOrder;
    },
    getContactor() {
      return this.$store.getters.getContactor || {};
    }
  },
  created() {
    this.orderType = parseInt(localStorage.getItem("mall-wap-refund-type"));
    if (this.isUnPicked) {
      this.getContactorData();
    }
    if (this.orderType === 1) {
      this.getMilkData();
      this.refundList[0].title = "未配送周期（退款）";
      this.refundList[0].det = "正在等待配送";
      this.refundList[1].title = "已配送周期（退款）";
      this.refundList[1].det = "正在配送中或已完成配送";
    } else {
      this.refundProductList = JSON.parse(
        localStorage.getItem("mall-wap-refund-list")
      );
    }
  },
  mounted() {
    // mall-wap-refund-list
    // console.log(this.orderType, "this.orderType");
    // this.refundProductList = JSON.parse(localStorage.REFUND_PRODUCT_LIST)
    // localStorage.REFUND_PRODUCT_LIST = JSON.stringify(this.refundProductList)
    // 多周期鲜奶原因切换
    // if (this.detail.isMultiCycle) {
    //   this.refundList = [
    //     {
    //       title: '我要退未配送周期（仅退款）',
    //       det: '鲜奶正在等待配送',
    //       path: `/user/order/applyrefund?refundType=1&finish=false`
    //     },
    //     {
    //       title: '我要退已配送周期（仅退款）',
    //       det: '鲜奶正在配送中或者已完成配送',
    //       path: `/user/order/applyrefund?refundType=1&finish=true`
    //     }
    //   ]
    // }
    // 清除local退款状态
    // localStorage.removeItem('REFUND_PRODUCT_STATUS_INDEX')
    // localStorage.removeItem('REFUND_REASIONINDEX')
    // localStorage.removeItem('REFUND_DET')
    // localStorage.removeItem('REFUND_FILELIST')
    // localStorage.removeItem('REFUND_FILELISTIMAGE')
  },
  methods: {
    // 顶部返回
    back() {
      // localStorage.removeItem('REFUND_DETALS')
      // localStorage.removeItem('REFUND_PRODUCT_LIST')
      this.$router.back(-1);
    },
    // 获取鲜奶售后数据
    getMilkData() {
      // getPeriodOptionalAfterOrder 鲜奶可申请售后周期
      this.$store
        .dispatch("order/getPeriodOptionalAfterOrder", {
          params: {
            orderSn: this.$route.query.orderSn
          }
        })
        .then(res => {
          // console.log(res);
          this.refundProductList.push(res.skuInfo);
        })
        .catch(() => {});
    },
    // 获取自提联系人信息
    getContactorData() {
      const params = {
        orderSn: this.$route.query.orderSn
      };
      this.$store
        .dispatch("order/getContactor", { params })
        .then(() => {})
        .catch(() => {});
    },
    goRefund(index, path) {
      // getPeriodOptionalAfterOrder
      if (
        index === 0 &&
        this.getPeriodOptionalAfterOrder.unFinishList &&
        this.getPeriodOptionalAfterOrder.unFinishList.length === 0
      ) {
        this.$dialog.alert({
          title: "提示",
          message: "您当前没有可申请售后的未配送周期",
          confirmButtonText: "好的",
          confirmButtonColor: "#DD9132"
        });
        // this.$toast('您当前没有可申请售后的未配送周期')
        return;
      }
      if (
        index === 1 &&
        this.getPeriodOptionalAfterOrder.finishList &&
        this.getPeriodOptionalAfterOrder.finishList.length === 0
      ) {
        this.$dialog.alert({
          title: "提示",
          message: "您当前没有可申请售后的已完成或正在配送的配送周期",
          confirmButtonText: "好的",
          confirmButtonColor: "#DD9132"
        });
        // this.$toast('您当前没有可申请售后的已完成或正在配送的配送周期')
        return;
      }
      this.$router.push(path);
    },
    onSubmitUnPicked() {
      const orderSn = this.$route.query.orderSn;
      this.$store
        .dispatch("order/addUnPickedAfterSale", {
          params: { orderSn }
        })
        .then(() => {
          this.toastLoading = this.$toast.loading({
            message: "提交中...",
            forbidClick: true,
            duration: 0
          });
          this.pollCount = 0;
          this.pollForAfterSaleId();
        })
        .catch(err => {
          this.$toast(err.msg || "提交失败，请重试");
        });
    },
    pollForAfterSaleId() {
      this.pollCount++;
      if (this.pollCount > 20) {
        if (this.toastLoading) {
          this.toastLoading.clear();
        }
        this.$toast("获取售后单超时，请稍后在售后列表中查看");
        this.$router.push("/order/refund/refundlist");
        return;
      }

      const orderSn = this.$route.query.orderSn;
      this.$store
        .dispatch("order/getManualCanceledAfterSaleIds", {
          params: { orderSn }
        })
        .then(res => {
          if (res) {
            if (this.toastLoading) {
              this.toastLoading.clear();
            }
            const afterSaleId = Array.isArray(res) ? res[0] : res;
            this.$router.push({
              path: "/order/refund/refunddetail",
              query: { id: afterSaleId }
            });
          } else {
            setTimeout(() => {
              this.pollForAfterSaleId();
            }, 2000);
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.pollForAfterSaleId();
          }, 2000);
        });
    }
  }
};
</script>

<style scoped>
.title_right {
  width: 36px;
}
.order_info {
  background: #fff;
}
/* 退款类型 */
.total_price1 {
  margin-top: 10px;
  padding: 0 15px;
  background: #fff;
  font-size: 16px;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
  line-height: 20px;
}
.bor_line {
  padding: 17px 0;
}
.bor_line_bottom {
  border-top: 1px solid #eee;
}
.go_right {
  margin-top: 15px;
  width: 20px;
  height: 20px;
}
.refund_det {
  margin-top: 4px;
  font-size: 14px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
}
/* 鲜奶多周期说明 */
.milk_det {
  background: rgba(251, 248, 217, 1);
  font-size: 12px;
  font-weight: 400;
  color: rgba(221, 145, 50, 1);
  line-height: 18px;
  padding: 10px 15px;
}
/* 自提未提货售后 */
.unpicked_con {
  .warn_con {
    background: #fff;
    padding: 12px 16px 16px;
    margin-top: 12px;
    .warn_title {
      color: #bf9264;
      padding-bottom: 12px;
    }
    .warn_text {
      color: #555;
    }
  }
  .info_con {
    background: #fff;
    padding: 16px;
    margin-top: 12px;
    .info_item {
      display: flex;
      line-height: 24px;
      .info_label {
        width: 90px;
        color: #888;
      }
      .info_val {
        color: #222;
        font-weight: 500;
      }
    }
  }
  .bottom_placeholder {
    height: 72px;
  }
  .bottom_btn_wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 8px 12px;
    box-shadow: 0 -2px 6px rgba(0, 0, 0, 0.05);
    z-index: 100;
    .submit_btn {
      background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
      border-radius: 2px;
      line-height: 40px;
      cursor: pointer;
    }
  }
}
</style>
